import { cn } from '@/utils';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import * as React from 'react';

const Separator = React.forwardRef((
    { className, orientation = 'horizontal', decorative = true, ...props },
    ref
) => (
    <SeparatorPrimitive.Root
        className={cn(
            'tw-shrink-0 tw-bg-border',
            orientation === 'horizontal' ? 'tw-h-[1px] tw-w-full' : 'tw-h-full tw-w-[1px]',
            className
        )}
        decorative={decorative}
        orientation={orientation}
        ref={ref}
        {...props}/>
));
Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };
